import { ref, computed } from 'vue'

const THEME_KEY = 'app-theme'
const VALID_THEMES = ['dark', 'light']

// 当前主题的响应式引用，供组件使用
const currentTheme = ref('dark')

const applyTheme = (theme) => {
  const next = VALID_THEMES.includes(theme) ? theme : 'dark'
  currentTheme.value = next

  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-theme', next)
    if (document.body) document.body.setAttribute('data-theme', next)
  }

  if (typeof window !== 'undefined') {
    window.localStorage.setItem(THEME_KEY, next)
  }
}

export const initTheme = () => {
  let initial = 'dark'

  if (typeof window !== 'undefined') {
    const saved = window.localStorage.getItem(THEME_KEY)
    if (VALID_THEMES.includes(saved)) {
      initial = saved
    }
  }

  applyTheme(initial)
}

export const setTheme = (theme) => {
  applyTheme(theme)
}

export const toggleTheme = () => {
  const next = currentTheme.value === 'dark' ? 'light' : 'dark'
  applyTheme(next)
}

export const getTheme = () => currentTheme.value

export const useTheme = () => {
  return {
    theme: currentTheme,
    isDark: computed(() => currentTheme.value === 'dark'),
    isLight: computed(() => currentTheme.value === 'light'),
    initTheme,
    setTheme,
    toggleTheme,
    getTheme
  }
}

